import _ from 'lodash';
import { baseUnit } from './baseUnit';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';
import { productAlias } from './productAlias';
import { productInvoiceName } from './productInvoiceName';

export function formatCallOffForLoadingManifest(loadingManifestDetails: any): any[] {
  const returnedOrders: any[] = [];
  _.forEach(loadingManifestDetails.callOffs, (callOffItem: any, callOffIndex: number) => {
    const description = productInvoiceName(productAlias(_.get(callOffItem, 'callOff.product')), callOffItem.lineNumber, callOffItem.itemNumber);
    const itemId = _.get(callOffItem, 'callOff.product._id', '');
    _.forEach(callOffItem.orders, (orderItem: any, orderIndex: number) => {
      const slNo = orderIndex == 0 ? `${callOffIndex + 1}/${loadingManifestDetails.callOffs.length}`: '';
      const packingMode =  _.get(callOffItem, 'callOff.product.packingMode');
      const unit1 = packingMode[0].unit1;
      const fg = _.get(orderItem, 'fg.0', {});
      const quantityInKg = orderItem.quantity + (orderItem.FOC || 0);
      const quantityA = `${kgToSellingUnitQuantity(callOffItem.callOff, fg, quantityInKg, unit1)} ${unit1}`;
      const unit2 = packingMode[0].unit2;
      const quantityB = `${kgToSellingUnitQuantity(callOffItem.callOff, fg, quantityInKg, unit2)} ${unit2}`;
      const unit3 = packingMode.length > 1 ? packingMode[1].unit2: '';
      const quantityC = unit3 ? `${kgToSellingUnitQuantity(callOffItem.callOff, fg, quantityInKg, unit3)} ${unit3}`: 'N/A';
      const obj = {
      slNo,
      itemId,
      description,
      order: _.get(orderItem, 'order', ''),
      unit: baseUnit(_.get(callOffItem, 'callOff.product', '')),
      quantityA,
      quantityB,
      quantityC
    }
    returnedOrders.push(obj);
    });
    
  })
  return returnedOrders;
}
